import { __, addIntlData } from 'first-intl';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { FormSelect, Validators, Toaster, useSafeState } from '@hugendubel/react-basic';
import { Salutation, Type, Money, EnumUtil, createCall, createCustomerCall, Method, WsErrorCode } from '@hugendubel/ws_client';
import { UserAgent, _, UrlUtil, ScrollUtil } from '@hugendubel/utils';
import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { WikiText } from '@hugendubel/wiki-renderer';

var intlData = {
	"footer.info.headline": "Hilfe zu:",
	"salutation.label": "Anrede",
	"salutation.frau": "Frau",
	"salutation.herr": "Herr",
	"salutation.divers": "Enby (divers)",
	"salutation.undefined": "Keine Angabe",
	"coverImage.altCover": "Cover",
	"validation.additionalAddress.required": "Bitte geben Sie einen zusätzliche Adresse an.",
	"validation.bankAccountOwner.required": "Bitte geben Sie einen Namen an.",
	"validation.city.required": "Bitte geben Sie einen Ort an.",
	"validation.companyName.required": "Bitte geben Sie einen Firmennamen an.",
	"validation.firstName.required": "Bitte geben Sie einen Vornamen an.",
	"validation.email.required": "Bitte geben Sie eine E-Mail-Adresse an.",
	"validation.houseNumber.required": "Bitte angeben",
	"validation.lastName.required": "Bitte geben Sie einen Nachnamen an.",
	"validation.password.required": "Bitte geben Sie ein Passwort an.",
	"validation.password.confirm": "Bitte geben Sie ein Passwort ein.",
	"validation.pw.repetition": "Die Wiederholung des Passworts stimmt nicht mit dem Passwort überein.",
	"validation.postNumber.required": "Bitte geben Sie eine Postnummer an.",
	"validation.salutation.required": "Bitte wählen Sie eine Anrede aus.",
	"validation.street.required": "Bitte geben Sie eine Straße an.",
	"validation.vicinityInput.required": "Bitte geben Sie einen Suchbegriff an.",
	"validation.zipCode.invalid": "Ungültig für das gewählte Land"
};

const SalutationOptions = [
    { label: { id: 'salutation.frau' }, value: Salutation.MRS },
    { label: { id: 'salutation.herr' }, value: Salutation.MR },
    { label: { id: 'salutation.divers' }, value: Salutation.PERSON },
    { label: { id: 'salutation.undefined' }, value: Salutation.UNDEFINED },
];
const FormSalutationPicker = ({ Field, name }) => (React.createElement(FormSelect, { Field: Field, name: name, label: "salutation.label", options: SalutationOptions }));

let _config;
/**
 * It is very important that the method gets called with the complete config.
 * And for now this will happen only once in application time. Right before
 * rendering starts and right after the initialization call returned the required
 * information. See ReactAppInit.run().
 */
const init = ({ hugendubel, orderSystemCode, properties: { mediaBaseUrl, googleMapsApiKey, giftWrapCosts, giftWrapPriceHint, pickupProperties, tolinoResellerId, webreaderBaseUrl, payAndCollectEnabled, deliveryTimeEstimationDefaultShippingMessage, deliveryTimeEstimationDHLShippingMessage, showPromisedDeliveryDate, giftWrapEnabled, }, }) => {
    _config = {
        mediaBaseUrl,
        googleMapsApiKey,
        orderSystemCode,
        giftWrapCosts,
        giftWrapPriceHint,
        pickupProperties,
        tolinoResellerId,
        webreaderBaseUrl,
        payAndCollectEnabled,
        deliveryTimeEstimationDefaultShippingMessage,
        deliveryTimeEstimationDHLShippingMessage,
        showPromisedDeliveryDate,
        giftWrapEnabled,
        hugendubel,
    };
};
const get = () => _config;
const Config = { init, get };

const parse$4 = (json) => ({
    orderSystemCode: Type.string(json.orderSystemCode, 'InitResult.orderSystemCode'),
    properties: parseProperties(Type.object(json.properties, 'InitResult.properties')),
});
const parseProperties = (json) => ({
    mediaBaseUrl: Type.string(json.mediaBaseUrl, 'Properties.mediaBaseUrl'),
    gtmId: Type.falsyToUndefined.string(json.gtmId, 'Properties.gtmId'),
    googleMapsApiKey: Type.falsyToUndefined.string(json.googleMapsApiKey, 'Properties.googleMapsApiKey'),
    giftWrapCosts: Money.parse(Type.number(json.giftWrapCosts, 'Properties.giftWrapCosts')),
    giftWrapPriceHint: Type.string(json.giftWrapPriceHint, 'Properties.giftWrapPriceHint'),
    pickupProperties: parsePickupProperties(Type.object(json.pickupProperties, 'Properties.pickupProperties')),
    trustedShopCustomerNumber: Type.falsyToUndefined.string(json.trustedShopCustomerNumber, 'Properties.trustedShopCustomerNumber'),
    tolinoResellerId: Type.string(json.tolinoResellerId, 'Properties.tolinoResellerId'),
    webreaderBaseUrl: Type.string(json.webreaderBaseUrl, 'Properties.webreaderBaseUrl'),
    payAndCollectEnabled: Type.boolean(json.payAndCollectEnabled, 'Properties.payAndCollectEnabled'),
    deliveryTimeEstimationDefaultShippingMessage: Type.optional.string(json.deliveryTimeEstimationDefaultShipping, 'Properties.deliveryTimeEstimationDefaultShipping'),
    deliveryTimeEstimationDHLShippingMessage: Type.optional.string(json.deliveryTimeEstimationDHLShipping, 'Properties.deliveryTimeEstimationDHLShipping'),
    showPromisedDeliveryDate: Type.boolean(json.showPromisedDeliveryDate, 'Properties.showPromisedDeliveryDate'),
    giftWrapEnabled: Type.boolean(json.giftWrapEnabled, 'Properties.giftWrapEnabled'),
});
const parsePickupProperties = (json) => ({
    forbidBranchPickupOverrideText: Type.optional.string(json.forbidBranchPickupOverrideText, 'PickupProperties.forbidBranchPickupOverrideText'),
    forbidBranchPickupOverrideDetailText: Type.optional.string(json.forbidBranchPickupOverrideDetailText, 'PickupProperties.forbidBranchPickupOverrideDetailText'),
});
const WsInitResult = { parse: parse$4 };

const parse$3 = (json) => Type.notEmptyString(json.code, 'OAuthCode.code');
const fromString = (raw) => raw;
const WsOAuthCode = { parse: parse$3, fromString };

const parse$2 = (result) => Type.string(result, 'DownloadUrl.url');
const WsDownloadUrl = { parse: parse$2 };

const parse$1 = (json) => {
    try {
        switch (json.type) {
            case 'tree':
                return parseTree(json);
            case 'text':
                return parseText(json);
            case 'orientation':
                return parseOrientation(json);
            case 'bold':
                return parseBold(json);
            case 'italic':
                return parseItalic(json);
            case 'underline':
                return parseUnderline(json);
            case 'footnote':
                return parseFootnote(json);
            case 'image':
                return parseImage(json);
            case 'headline1':
                return parseHeadline1(json);
            case 'headline2':
                return parseHeadline2(json);
            case 'headline3':
                return parseHeadline3(json);
            case 'headline4':
                return parseHeadline4(json);
            case 'headline5':
                return parseHeadline5(json);
            case 'headline6':
                return parseHeadline6(json);
            case 'break':
                return { type: 'break' };
            case 'linebreak':
                return { type: 'linebreak' };
            case 'pagebreak':
                return { type: 'pagebreak' };
            case 'trenner':
                return { type: 'trenner' };
            case 'price-label':
                return parsePriceLabel(json);
            case 'order-button':
                return parseOrderButton(json);
            case 'price-label-with-order-button':
                return parsePriceLabelWithOrderButton(json);
            case 'rating':
                return parseRating(json);
            case 'link':
                return parseLink(json);
            default:
                break;
        }
    }
    catch (e) {
        // No error explicit error handling. Just return an unknown node. This way, a sub-tree can be invalid,
        // but we can still render the rest of the wikitext.
    }
    return { type: 'unknown' };
};
const parseTree = (json) => {
    const children = Type.array(json.content, 'TreeNode.content');
    return { type: 'tree', children: children.map(parse$1) };
};
const parseText = (json) => ({
    type: 'text',
    content: Type.optional.string(json.content, 'TextNode.content') || '',
});
const parseAlignment = (raw) => {
    if (raw === 'left' || raw === 'right' || raw === 'center' || raw === 'justify') {
        return raw;
    }
    return undefined;
};
const parseOrientation = (json) => {
    const children = Type.array(json.content, 'OrientationNode.content');
    return { type: 'orientation', alignment: parseAlignment(json.align), children: children.map(parse$1) };
};
const parseBold = (json) => {
    const children = Type.array(json.content, 'BoldNode.content');
    return { type: 'bold', children: children.map(parse$1) };
};
const parseItalic = (json) => {
    const children = Type.array(json.content, 'ItalicNode.content');
    return { type: 'italic', children: children.map(parse$1) };
};
const parseUnderline = (json) => {
    const children = Type.array(json.content, 'UnderlineNode.content');
    return { type: 'underline', children: children.map(parse$1) };
};
const parseFootnote = (json) => {
    const children = Type.array(json.content, 'FootnoteNode.content');
    return { type: 'footnote', children: children.map(parse$1) };
};
const parseImageSource = (json) => {
    switch (json.type) {
        case 'cms':
            return { type: 'cms', path: Type.optional.string(json.path, 'ImageSource.path') };
        case 'product':
            return {
                type: 'product',
                coverUrlPath: Type.optional.string(json['cover-image-path'], 'ImageSource.cover-image-path'),
                id: Type.optional.number(Number(json['id']), 'ImageSourceType.id'),
            };
        case 'external':
            return { type: 'external', url: Type.optional.string(json.url, 'ImageSource.url') };
        default:
            return { type: 'external', url: '#' };
    }
};
const parseImage = (json) => {
    const alignment = parseAlignment(json.align);
    const width = Number(json.width) || undefined;
    const height = Number(json.height) || undefined;
    const source = parseImageSource(Type.object(json.source, 'ImageNode.source'));
    return { type: 'image', alignment, width, height, source };
};
const parseHeadline1 = (json) => {
    const children = Type.array(json.content, 'Headline1.content');
    return { type: 'headline1', children: children.map(parse$1) };
};
const parseHeadline2 = (json) => {
    const children = Type.array(json.content, 'Headline2.content');
    return { type: 'headline2', children: children.map(parse$1) };
};
const parseHeadline3 = (json) => {
    const children = Type.array(json.content, 'Headline3.content');
    return { type: 'headline3', children: children.map(parse$1) };
};
const parseHeadline4 = (json) => {
    const children = Type.array(json.content, 'Headline4.content');
    return { type: 'headline4', children: children.map(parse$1) };
};
const parseHeadline5 = (json) => {
    const children = Type.array(json.content, 'Headline5.content');
    return { type: 'headline5', children: children.map(parse$1) };
};
const parseHeadline6 = (json) => {
    const children = Type.array(json.content, 'Headline6.content');
    return { type: 'headline6', children: children.map(parse$1) };
};
const parsePriceLabel = (json) => ({
    type: 'price-label',
    price: Type.optional.number(Number(json.price), 'PriceLabelNode.price'),
});
const parseOrderButton = (json) => ({
    type: 'order-button',
    articleId: Type.optional.number(Number(json.id), 'OrderButtonNode.id'),
});
const parsePriceLabelWithOrderButton = (json) => ({
    type: 'price-label-with-order-button',
    price: Type.optional.number(Number(json.price), 'PriceLabelWithOrderButtonNode.price'),
    articleId: Type.optional.number(Number(json.id), 'PriceLabelWithOrderButtonNode.id'),
});
const parseRating = (json) => ({
    type: 'rating',
    ratingAverage: Type.optional.number(Number(json['rating-average']), 'RatingNode.rating-average'),
});
const parseLinkData = (json) => {
    switch (json['link-type']) {
        case 'nav':
            return {
                type: 'nav',
                naviId: Type.number(Number(json['navi-id']), 'LinkData.navi-id'),
                linkText: Type.optional.string(json['link-text'], 'LinkData.link-text'),
            };
        case 'product':
            return { type: 'product', articleId: Type.number(Number(json['article-id']), 'LinkData.article-id') };
        case 'extern':
            return { type: 'extern', url: Type.string(json.url, 'LinkData.url') };
        case 'mail':
            return { type: 'mail', recipient: Type.string(json.recipient, 'LinkData.recipient') };
        case 'bestseller':
            return { type: 'bestseller', naviId: Type.number(Number(json['navi-id']), 'LinkData.navi-id') };
        case 'cms':
            return { type: 'cms', imageUrl: Type.string(json['image-url'], 'LinkData.image-url') };
        default:
            return { type: 'unknown' };
    }
};
const parseLink = (json) => ({
    type: 'link',
    linkData: parseLinkData(json),
    anchor: Type.optional.string(json.anchor, 'LinkNode.anchor'),
    rel: Type.optional.string(json.rel, 'LinkNode.rel'),
    target: Type.optional.string(json.target, 'LinkNode.target'),
    label: json.label ? parse$1(json.label) : undefined,
});
const WsWikiText = { parse: parse$1 };

var ContextHelpType;
(function (ContextHelpType) {
    ContextHelpType["LOGIN"] = "LOGIN";
    ContextHelpType["CREATE_ACCOUNT"] = "CREATE_ACCOUNT";
    ContextHelpType["EDIT_ACCOUNT"] = "EDIT_ACCOUNT";
    ContextHelpType["EDIT_NEWSLETTER"] = "EDIT_NEWSLETTER";
    ContextHelpType["EDIT_ADDRESSES"] = "EDIT_ADDRESSES";
    ContextHelpType["LIST_BONUS"] = "LIST_BONUS";
    ContextHelpType["REVIEW"] = "REVIEW";
    ContextHelpType["ADV_SEARCH"] = "ADV_SEARCH";
    ContextHelpType["EBOOK_HISTORY"] = "EBOOK_HISTORY";
    ContextHelpType["AUDIO_BOOK_HISTORY"] = "AUDIO_BOOK_HISTORY";
    ContextHelpType["COUPON_HISTORY"] = "COUPON_HISTORY";
    ContextHelpType["INVOICE_LIST"] = "INVOICE_LIST";
    ContextHelpType["DELECT_ACCOUNT"] = "DELECT_ACCOUNT";
    ContextHelpType["BONUS_SHOP"] = "BONUS_SHOP";
    ContextHelpType["GIFT_CHECKOUT"] = "GIFT_CHECKOUT";
    ContextHelpType["GIFT_LANDING_PAGE"] = "GIFT_LANDING_PAGE";
    ContextHelpType["CART"] = "CART";
    ContextHelpType["LASTCHECK"] = "LASTCHECK";
    ContextHelpType["ORDER_CONFIRMATION"] = "ORDER_CONFIRMATION";
    ContextHelpType["ORDER"] = "ORDER";
    ContextHelpType["NEW_ORDER_PROCESS_PAYMENT"] = "NEW_ORDER_PROCESS_PAYMENT";
    ContextHelpType["SUBSCRIPTIONS"] = "SUBSCRIPTIONS";
    ContextHelpType["TOLINO"] = "TOLINO";
    ContextHelpType["PAYMENT_OPTIONS"] = "PAYMENT_OPTIONS";
    ContextHelpType["WHISHLIST"] = "WHISHLIST";
    ContextHelpType["ORDER_HISTORY"] = "ORDER_HISTORY";
})(ContextHelpType || (ContextHelpType = {}));
const parseHelpType = EnumUtil.parser({
    enumValues: ContextHelpType,
    enumTypeName: 'Context help type',
});
const parseContextHelp = (json) => ({
    type: parseHelpType(json.type),
    wikitext: WsWikiText.parse(Type.object(json.wikitext, 'ContextHelp.wikitext')),
});
const WsContetxtHelp = { parseContextHelp };

const WS = {
    contextHelp: {
        byType: createCall({
            name: 'contexthelp/bytype',
            parser: WsContetxtHelp.parseContextHelp,
        }),
    },
    download: {
        url: createCustomerCall({ name: 'download/url', parser: WsDownloadUrl.parse }),
    },
    shoppingCart: {
        init: createCall({
            name: 'shoppingcart/init',
            parser: WsInitResult.parse,
        }),
    },
    oAuthInternal: {
        authorizeCode: createCustomerCall({
            name: 'oauthinternal/authorize/code',
            parser: WsOAuthCode.parse,
            method: Method.POST,
        }),
    },
};

const Globals = {
    window: () => window,
    body: () => document.body,
};

const _ReactAppInit = {};
_ReactAppInit.filterDuplicates = (strings) => strings.reduce((result, value) => {
    if (!result.includes(value)) {
        result.push(value);
    }
    return result;
}, []);
const setDeviceFeatures = () => {
    const bodyClasses = Globals.body().className.split(' ');
    // currently there is only one supported device that doesn't
    // support fixed positioning and a bunch of different functionality.
    // Speaking of the Tolino Shine 1 which runs currently on Android 2.3.4.
    const deviceClasses = UserAgent.outdatedCSS ? ['no-fixed', 'no-flex', 'no-svg', 'no-borderbox'] : [];
    const eInkClasses = UserAgent.eInk ? ['e-ink'] : [];
    const tolinoClasses = UserAgent.tolino ? ['is-tolino'] : [];
    Globals.body().className = _ReactAppInit
        .filterDuplicates(bodyClasses.concat(deviceClasses).concat(eInkClasses).concat(tolinoClasses))
        .join(' ');
};
const run = () => {
    setDeviceFeatures();
    return WS.shoppingCart.init({ url: Globals.window().location.href }).then(result => {
        Config.init(result);
        return result;
    });
};
const ReactAppInit = { run, setDeviceFeatures };

const _DownloadService = {};
// This calls tries to poll if the Api responded with a certain error code
// which usually indicates that the download will be available shortly (within the next few seconds)
const _loadUrl = (downloadId, retries) => WS.download.url({ downloadId }).catch(({ errorCode, message }) => {
    if (errorCode === WsErrorCode.DOWNLOAD_NOT_YET_AVAILABLE)
        return retries > 0 ? _.sleep(1000).then(() => _loadUrl(downloadId, retries - 1)) : undefined;
    else if (errorCode !== WsErrorCode.DOWNLOAD_NOT_YET_ALLOWED)
        Track.error(TRACK_ID('2019-03-26 03:32:20'), `Unable to load the download URL for ID ${downloadId}: ${message}`);
});
// this method is used by the checkout which has a little different polling behaviour
// therefore we do not retry within this method
// TODO: maybe we should rework this after the customer app was launched and tested successfully with the new polling mechanics
const loadUrl = (downloadId) => _loadUrl(downloadId, 0);
// here comes the polling strategy within the customer app. It needs to be a little different
// than the one from the checkout, because directly after ordering it might take almost a minute to
// deliver the downloads to the customer
const POLLING_RETRIES = 4;
const pollUrl = (downloadId) => _loadUrl(downloadId, POLLING_RETRIES);
const URL_EX = /([^?#]+)(\?[^#]*)?(#.*)?/;
_DownloadService.appendAuthCodeToUrl = (url, authCode) => {
    const urlMatch = URL_EX.exec(url);
    if (!urlMatch) {
        // apparently no valid url. Don't append the auth code, just return the url without auth code, maybe it is valid
        // in some way we did not anticipate
        return url;
    }
    const baseUrl = urlMatch[1];
    const query = urlMatch[2];
    const fragment = urlMatch[3];
    const params = UrlUtil.locationSearchToQuery(query);
    const paramsWithCode = { ...params, code: authCode };
    return baseUrl + UrlUtil.queryToSearch(paramsWithCode) + (fragment || '');
};
const applyOAuthCode = (url) => {
    const clientId = process.env.IS_HUDU ? '4c20de744aa8b83b79b692524c7ec6ae' : 'ebookde0501html5readerV0001';
    return WS.oAuthInternal
        .authorizeCode({ client_id: clientId })
        .then(authCode => _DownloadService.appendAuthCodeToUrl(url, authCode))
        .catch(e => {
        Track.error(TRACK_ID('2020-01-21 01:26:36'), 'Unable to load oAuth code: ' + e.message);
    });
};
const DownloadService = { applyOAuthCode, loadUrl, pollUrl };

const Germany = { displayName: 'Deutschland', isoCode: 'DE' };
const parse = (json) => {
    const displayName = Type.notEmptyString(json.name, 'Country.name');
    const isoCode = Type.notEmptyString(json.isoCode, 'Country.isoCode');
    return { displayName, isoCode };
};
const parseList = (json) => {
    const countriesJson = Type.array(json.items, 'CountriesByCode.items');
    const countries = countriesJson.filter(item => item).map(parse);
    const result = {};
    countries.forEach(country => {
        result[country.isoCode] = country;
    });
    return result;
};
const WsCountry = { parse, parseList, Germany };

const ZIP_CODE_4_DIGITS_COUNTRIES = ['AT', 'CH'];
const zipCode4Digits = Validators.withModifiedMessage(Validators.number({ minLength: 4, maxLength: 4, trim: true }), { id: 'validation.zipCode.invalid' });
const ZIP_CODE_5_DIGITS_COUNTRIES = ['DE', 'IT', 'FR', 'ES'];
const zipCode5Digits = Validators.withModifiedMessage(Validators.number({ minLength: 5, maxLength: 5, trim: true }), { id: 'validation.zipCode.invalid' });
const zipCodeGeneral = Validators.string({ min: 1, max: 10, trim: true, minMsg: { id: 'validation.zipCode.invalid' } });
const zipCode = (country) => {
    if (ZIP_CODE_5_DIGITS_COUNTRIES.includes(country))
        return zipCode5Digits;
    else if (ZIP_CODE_4_DIGITS_COUNTRIES.includes(country))
        return zipCode4Digits;
    else
        return zipCodeGeneral;
};
const WsValidators = {
    ...Validators,
    city: Validators.validNameAndAddressChars({
        min: 1,
        max: 50,
        trim: true,
        minMsg: { id: 'validation.city.required' },
    }),
    zipCode,
    street: Validators.validNameAndAddressChars({
        min: 1,
        max: 100,
        trim: true,
        minMsg: { id: 'validation.street.required' },
    }),
    houseNumber: Validators.string({ min: 1, max: 10, trim: true, minMsg: { id: 'validation.houseNumber.required' } }),
    firstName: Validators.validNameAndAddressChars({
        min: 1,
        max: 30,
        trim: true,
        minMsg: { id: 'validation.firstName.required' },
    }),
    lastName: Validators.validNameAndAddressChars({
        min: 1,
        max: 30,
        trim: true,
        minMsg: { id: 'validation.lastName.required' },
    }),
    companyName: Validators.string({ min: 1, max: 30, trim: true, minMsg: { id: 'validation.companyName.required' } }),
    salutation: Validators.required({ id: 'validation.salutation.required' }),
    emailChange: Validators.required({ id: 'validation.email.required' }),
    passwordChange: Validators.string({ min: 1, max: 100, minMsg: { id: 'validation.password.required' }, trim: true }),
    passwordConfirm: Validators.mandatoryString({ msg: { id: 'validation.password.confirm' }, trim: true }),
    bankAccountOwner: Validators.string({
        min: 1,
        max: 50,
        trim: true,
        minMsg: { id: 'validation.bankAccountOwner.required' },
    }),
    giftCardPin: Validators.string({ min: 1, trim: true, minMsg: { id: 'addCoupon.error.noPin' } }),
    vicinityInput: Validators.mandatoryString({ msg: { id: 'validation.vicinityInput.required' } }),
    postNumber: Validators.string({ min: 1, max: 100, trim: true, minMsg: { id: 'validation.postNumber.required' } }),
    additionalAddress: Validators.validNameAndAddressChars({
        min: 1,
        max: 30,
        trim: true,
        minMsg: { id: 'validation.additionalAddress.required' },
    }),
};

const _UsePositionFixed = {};
_UsePositionFixed.calculate = () => {
    const offset = ScrollUtil.getOffset();
    return {
        pos: offset,
        isTop: offset === 0,
        isBottom: offset + Globals.window().innerHeight === ScrollUtil.getTotalHeight(),
    };
};
const usePositionFixed = () => {
    const [state, setState] = useState(_UsePositionFixed.calculate);
    const lastState = useRef(state);
    lastState.current = state;
    /**
     * This is actually the core logic to update the displayed scroll buttons
     * whenever necessary.
     *
     * Why did we decide to update the displayed buttons once a second?
     * -> We have to update it, whenever the page size changes. This needs two listeners:
     *    ResizeObserver on the root node and whenever an image finished loading.
     * -> We have also to update whenever the scroll position was changed by the user
     *    (especially without hitting the buttons but using native scrolling)
     * -> That's a huge complexity overhead.
     * -> E-Ink devices don't benefit so much from those on-time updates.
     * -> There would be by far more updates than only updating once a second
     *
     * ATTENTION: Even if you might think that it looks weird on non-e-ink devices.
     *            Those scroller buttons are designed for e-ink devices. Therefore
     *            test how it feels on those devices.
     */
    useEffect(() => {
        Globals.window().setInterval(() => {
            const current = _UsePositionFixed.calculate();
            if (current.pos !== lastState.current.pos || current.isBottom !== lastState.current.isBottom) {
                setState(current);
            }
        }, 1000);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const update = useCallback(() => {
        setState(_UsePositionFixed.calculate());
    }, []);
    return { ...state, update, style: UserAgent.outdatedCSS ? { top: `${state.pos}px` } : undefined };
};

const OutdatedCssToaster = () => {
    const { style } = usePositionFixed();
    return React.createElement(Toaster.Component, { style: style });
};

const _UseScroller = {};
const SCROLL_OVERLAP = 100;
_UseScroller.scrollBy = (factor) => ScrollUtil.scrollBy(factor * Math.max(Globals.window().innerHeight - SCROLL_OVERLAP, SCROLL_OVERLAP));
const useScroller = () => {
    const { update, ...rest } = usePositionFixed();
    const scrollUp = useCallback(() => {
        _UseScroller.scrollBy(-1);
        update();
    }, [update]);
    const scrollDown = useCallback(() => {
        _UseScroller.scrollBy(1);
        update();
    }, [update]);
    return { ...rest, scrollUp, scrollDown };
};

const EInkScroller = () => {
    const { style, isTop, isBottom, scrollUp, scrollDown } = useScroller();
    return (React.createElement("div", { className: "scroll-pager", style: style },
        isTop || React.createElement("div", { className: "btn btn-default scroll-page-up icon-scrollpager-up", onClick: scrollUp }),
        isBottom || (React.createElement("div", { className: "btn btn-default scroll-page-down icon-scrollpager-down", onClick: scrollDown }))));
};

const WikitextAccordion = ({ header, body }) => {
    const [open, setOpen] = useState(false);
    const toggleOpen = useCallback(() => setOpen(b => !b), []);
    const mediaServerUrl = Config.get().mediaBaseUrl;
    return (React.createElement("div", { className: "accordion-item" },
        React.createElement("div", { className: _.classNames('acc-head', 'toggle-collapse', open && 'active'), onClick: toggleOpen },
            React.createElement(WikiText, { node: header, classPrefix: 'context-help-', mediaServerUrl: mediaServerUrl })),
        React.createElement("div", { className: _.classNames('acc-body', !open && 'collapse') },
            React.createElement(WikiText, { node: body, classPrefix: 'context-help-', mediaServerUrl: mediaServerUrl }))));
};

const renderHelpElements = (node) => {
    const mediaUrl = Config.get().mediaBaseUrl;
    const classPrefix = 'context-help-';
    if (node.type !== 'tree') {
        return [React.createElement(WikiText, { key: 0, node: node, mediaServerUrl: mediaUrl, classPrefix: classPrefix })];
    }
    const children = node.children;
    const result = [];
    for (let i = 0; i < children.length; i++) {
        // the context help is only structured as wikitext, so we have to use heuristics: a headline2 followed by text
        // (or aligned text) is interpreted as accordion, everything else is just plainly rendered
        const current = children[i];
        if (current.type === 'headline2' &&
            children.length > i + 1 &&
            (children[i + 1].type === 'text' || children[i + 1].type === 'orientation')) {
            result.push(React.createElement(WikitextAccordion, { header: current, body: children[i + 1], key: i }));
            // we used two children here (the current and the next one), so we jump over the next one
            i += 1;
        }
        else {
            result.push(React.createElement(WikiText, { node: current, mediaServerUrl: mediaUrl, classPrefix: classPrefix, key: i }));
        }
    }
    return result;
};
const ContextHelpDisplay = ({ help: { wikitext }, helpHeadline }) => (React.createElement("div", { className: "context-help" },
    React.createElement("div", { className: "h2" }, helpHeadline || __('footer.info.headline')),
    React.createElement("div", { className: "accordion" }, renderHelpElements(wikitext))));

// This is fire and forget: If the context help is not available, it's not nice but the user can still carry on.
const loadContextHelp = (type) => WS.contextHelp.byType({ type }).catch(error => {
    if (error.errorCode !== WsErrorCode.NO_CONTEXT_HELP) {
        // some unexpected error occurred
        Track.error(TRACK_ID('2019-07-02 11:31:45'), 'Error while fetching context help of type ' + type + ': ' + error.message);
    }
    return undefined;
});
const HelpService = { loadContextHelp };

const _ContextHelpPanel = {
    CACHE: {},
};
const ContextHelpPanel = ({ type, helpHeadline }) => {
    const [help, setHelp] = useSafeState(undefined);
    useEffect(() => {
        // fetch context help if it is not in the cache.
        // Important: the cache may store undefined values (so we can cache that no help is available), so we must
        // use the 'in' keyword here.
        if (!(type in _ContextHelpPanel.CACHE)) {
            HelpService.loadContextHelp(type).then(contextHelp => {
                // even if no context help for this type. explicitly store undefined in the cache
                // even for unexpected error cases. In worst case the user has to perform a page reload
                _ContextHelpPanel.CACHE[type] = contextHelp;
                setHelp(contextHelp);
            });
        }
        else {
            setHelp(_ContextHelpPanel.CACHE[type]);
        }
    }, [type, setHelp]);
    return help ? React.createElement(ContextHelpDisplay, { help: help, helpHeadline: helpHeadline }) : null;
};

addIntlData(intlData);

export { Config, ContextHelpPanel, ContextHelpType, DownloadService, EInkScroller, FormSalutationPicker, OutdatedCssToaster, ReactAppInit, WsCountry, WsInitResult, WsValidators, WsWikiText, usePositionFixed };
